import { formatDate } from "../../../../../utils";

export function useFiltrosHandlers(setFiltrosAvancados) {
  const onChangeInput = (event) => {
    const value = event.target.value || null;
    setFiltrosAvancados((prev) => ({ ...prev, [event.target.name]: value }));
  };

  const onChangeAutocomplete = (id, value) => {
    setFiltrosAvancados((prev) => ({
      ...prev,
      [id]: value ? value.id : undefined,
    }));
  };

  const onChangeDate = (id, date) => {
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (!date || !isValidDate(date)) date = null;

    if (date?.getFullYear() > 2000) {
      const formattedDate = formatDate.toSend(date);

      setFiltrosAvancados((prev) => {
        const newFiltro = { ...prev, [id]: formattedDate };
        const isStart = id.endsWith("Start");
        const oppositeId = isStart
          ? id.replace("Start", "End")
          : id.replace("End", "Start");

        if (!newFiltro[oppositeId]) {
          newFiltro[oppositeId] = formattedDate;
        }
        return newFiltro;
      });
    }
  };

  const onChangeCheckbox = (event) => {
    setFiltrosAvancados((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked ?? null,
    }));
  };

  return {
    onChangeInput,
    onChangeAutocomplete,
    onChangeDate,
    onChangeCheckbox,
  };
}
